export default __webpack_public_path__ + "static/media/misc-pantry3-1440w.a5b8036b.png";